import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapProjectManagerOptions = (
  manager: UCM.ProjectManagerOptionRawType,
  id: string,
): UCM.ProjectManagerOptionType => ({
  value: id,
  label: `${manager.first_name} ${manager.last_name}`,
});

const getProjectManagerOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.ProjectManagerOptionRawType>
  >(API.GET.projectManagerOptions);
  return data.data.map(({ attributes, id }) =>
    mapProjectManagerOptions(attributes, id),
  );
};

export const useGetProjectManagerOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PROJECT_MANAGER_OPTIONS],
    queryFn: getProjectManagerOptions,
    ...config,
  });
};
